<template>
  <el-dialog :visible.sync="isPopup"
             title="编辑返佣"
             :close-on-click-modal="false"
             :before-close="close"
             :close-on-press-escape="false">
    <div class="slotRebate" :style="{'max-height':maxHeight}">
      <el-form>
        <el-form-item label="返佣组件名称">
          <p>{{ formData.name }}</p>
        </el-form-item>
        <el-form-item label="ID">
          <p>{{ formData.settingId }}</p>
        </el-form-item>
        <el-form-item label="支持平台">
          <el-checkbox-group v-model="formData.platform">
            <el-checkbox v-for="item in formData.platform" :label="item" :key="item" disabled>{{ item }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="termBtn">
        <el-button type="primary" size="small" @click="addRebateLevel">增加代理层级</el-button>
        <el-button type="primary" size="small" @click="delRebateLevel">删除代理层级</el-button>
      </div>
      <div class="symbolType">
        <div class="title"><span>产品返佣设置</span></div>
        <div class="typeNav">
          <ul>
            <li v-for="symbol in symbolTypeData"
                @click="changeSymbolType(symbol)"
                :class="{'checked':symbolTypeZone==symbol.zone}">
              <p>{{ symbol.name }}</p>
            </li>
          </ul>
        </div>
        <div class="symbol-list">
          <div id="symbol" :style="{'width':formData.totalMap?(formData.totalMap.length+1) * 160 + 'px':0}">
            <div class="symbol">
              <ul>
                <li><p>产品</p></li>
                <li v-for="item in formData.totalMap"><p>{{ item.level }}级代理返佣（美元）</p></li>
              </ul>
              <ul>
                <li><p>全部</p></li>
                <li v-for="(item,index) in formData.totalMap">
                  <el-input v-model="item.amount" @input="changeAllAmount(item,index)" type="number"></el-input>
                </li>
              </ul>
            </div>
            <div class="symbol">
              <ul>
                <li><p>产品</p></li>
                <li v-for="item in formData.totalMap"><p>{{ item.level }}级代理返佣（美元）</p></li>
              </ul>
              <ul v-for="(item,index) in formData.rule" v-show="item.zone==symbolTypeZone">
                <li><p>{{ item.symbol }}</p></li>
                <li v-for="(level,subIndex) in item.rule">
                  <inputDiv :amount="level.amount" :index="index" :subIndex="subIndex"
                            @inputAmount="inputAmount"></inputDiv>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="slotFixedBtn">
      <el-button @click="close()">{{ $t('page.cancel') }}</el-button>
      <el-button type="primary" @click="submitRebate()">{{ $t('page.submit') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import inputDiv from '@/views/agent/components/inputDiv.vue'
import Url from '@/views/agent/util/url'
import DateUtil from '@/utils/dataUtil'
import Qs from 'qs'

export default {
  name: 'slotRebate',
  props: ['slotData', 'isShow'],
  components: { inputDiv },
  data() {
    return {
      maxHeight: '',
      formData: {},
      inputData: {},
      symbolWidth:0,
      symbolTypeData: [
        { name: '外汇', zone: 2 },
        { name: '商品', zone: 4 },
        { name: '指数', zone: 5 },
        { name: '货币', zone: 6 },
        { name: '股票', zone: 7 }
      ],
      symbolTypeZone: 2,
      num: 1,
      symbolData: [],
      isPopup: this.isShow
    }
  },
  methods: {
    docHeight() {
      let docHeight = window.innerHeight || document.documentElement.clientHeight
      this.maxHeight = docHeight / 1.8 + 'px'
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    close() {
      this.isPopup = false
      this.$emit('changeSlotRebate', this.isPopup)
    },
    addRebateLevel() {
      let arr = {}
      this.num++
      arr = { level: this.num, amount: '' }
      let formData = JSON.parse(JSON.stringify(this.formData))
      formData.totalMap.push(arr)
      for (const i in formData.rule) {
        formData.rule[i].rule.push(arr)
      }
      this.formData = formData
      this.$forceUpdate()
    },
    delRebateLevel() {
      let index = this.formData.totalMap.length - 1
      if (index > 0) {
        this.num = index
        this.formData.totalMap.splice(index, 1)
        for (const i in this.formData.rule) {
          this.formData.rule[i].rule.splice(index, 1)
        }
      }
      this.$forceUpdate()
    },
    initSymbol() {
      this.$axios.get(Url.adAgent.symbolList).then(res => {
        if (res.code == 0) {
          if (res.result && res.result.length > 0) {
            this.symbolData = res.result
            this.num = this.slotData.level > 0 ? this.slotData.level : 1
            this.formData.name = this.slotData.name
            this.formData.settingId = this.slotData.settingId
            this.formData.platform = this.slotData.platform
            this.formData.totalMap = this.slotData.totalMap
            this.formData.rule = []
            for (const i in this.symbolData) {
              this.symbolTypeData.forEach(e => {
                if (e.zone == this.symbolData[i].zone) {
                  this.formData.rule.push({
                    zone: this.symbolData[i].zone,
                    symbol: this.symbolData[i].symbol,
                    rule: []
                  })
                }
              })
            }
            for (const i in this.formData.rule) {
              this.formData.rule[i].rule = this.formData.totalMap
              for (const j in this.slotData.rule) {
                if (this.formData.rule[i].symbol == this.slotData.rule[j].symbol) {
                  this.formData.rule[i].rule = this.slotData.rule[j].rule
                }
              }
            }
            this.$forceUpdate()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    changeSymbolType(symbol) {
      this.symbolTypeZone = symbol.zone
      for (const i in this.formData.rule) {
        if (this.formData.rule[i].zone == this.symbolTypeZone) {
          for (const j in this.formData.rule[i].rule) {
            if (DateUtil.isEmpty(this.formData.rule[i].rule[j].amount)) {
              if (JSON.stringify(this.inputData) != '{}') this.inputData.rule[i].rule[j].amount = JSON.parse(JSON.stringify(this.formData.totalMap[j].amount))
              this.formData.rule[i].rule[j].amount = JSON.parse(JSON.stringify(this.formData.totalMap[j].amount))
            }
          }
        }
      }
      this.$forceUpdate()
    },
    changeAllAmount(obj, index) {
      for (const i in this.formData.rule) {
        if (this.formData.rule[i].zone == this.symbolTypeZone) {
          if (JSON.stringify(this.inputData) != '{}') this.inputData.rule[i].rule[index].amount = JSON.parse(JSON.stringify(obj.amount))
          this.formData.rule[i].rule[index].amount = JSON.parse(JSON.stringify(obj.amount))
        }
      }
      this.$forceUpdate()
    },
    inputAmount(option) {
      let formData = JSON.stringify(this.inputData) != '{}' ? JSON.parse(JSON.stringify(this.inputData)) : JSON.parse(JSON.stringify(this.formData))
      formData.rule[option.index].rule[option.subIndex].amount = option.amount
      this.inputData = formData
    },
    /*编辑返佣提交数据触发事件*/
    submitRebate() {
      let formData = JSON.stringify(this.inputData) != '{}' ? JSON.parse(JSON.stringify(this.inputData)) : JSON.parse(JSON.stringify(this.formData))
      delete formData.totalMap
      formData.platform = formData.platform.join(',')
      formData.rule = JSON.stringify(formData.rule)
      this.dataChange(Url.adAgent.symbolEdit, formData, res => {
        if (res.code == 0) {
          this.isPopup = false
          this.$emit('changeSlotRebate', this.isPopup)
          this.formData = formData
          this.$message.success('操作成功')
        } else {
          this.formData = formData
          this.$message.error(res.message)
        }
      })
    }
  },
  mounted() {
    this.docHeight()
    this.initSymbol(2)
  }
}
</script>

<style>
.slotRebate {
  overflow-x: hidden;
  overflow-y: scroll;
}
.slotRebate .el-form-item {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.slotRebate .el-form-item__content {
  width: 80%;
}
.slotRebate .el-form-item__content p {
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}
.slotRebate .termBtn {
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  padding-top: 20px;
  border-top: solid 1px #ddd;
}
.slotRebate .symbolType .title {
  overflow: hidden;
  margin-bottom: 20px;
}
.slotRebate .symbolType .title span {
  overflow: hidden;
  display: block;
  font-size: 14px;
  color: #606266;
}
.slotRebate .symbolType .typeNav {
  overflow: hidden;
}
.slotRebate .symbolType .typeNav ul {
  display: flex;
  justify-content: flex-start;
}
.slotRebate .symbolType .typeNav ul li {
  overflow: hidden;
  padding: 5px 20px;
  border: solid 1px #ddd;
  margin-right: 10px;
  border-radius: 4px;
  cursor: pointer;
}
.slotRebate .symbolType .typeNav ul li p {
  overflow: hidden;
  display: block;
  font-size: 14px;
  color: #606266;
}
.slotRebate .symbolType .typeNav ul li.checked {
  background: var(--brand-primary-hover);
  border: solid 1px var(--brand-primary-hover);
}
.slotRebate .symbolType .typeNav ul li.checked p {
  color: #fff;
}
.slotRebate .symbolType .symbol-list {
  overflow-x: scroll;
  margin-top: 10px;
}
.slotRebate .symbolType .symbol-list .symbol {
  overflow: hidden;
  border: solid 1px #ddd;
  margin: 10px 0 30px;
}
.slotRebate .symbolType .symbol-list .symbol ul {
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: solid 1px #ddd;
}
.slotRebate .symbolType .symbol-list .symbol ul:last-child {
  border-bottom: none;
}
.slotRebate .symbolType .symbol-list .symbol li {
  border-right: solid 1px #ddd;
  width: 160px;
  float: left;
  list-style: none;
}
.slotRebate .symbolType .symbol-list .symbol li:last-child {
  border-right: none;
}
.slotRebate .symbolType .symbol-list .symbol li p,
.slotRebate .symbolType .symbol-list .symbol li .inputDiv {
  overflow: hidden;
  display: block;
  font-size: 14px;
  color: #606266;
  padding: 0 10px;
  line-height: 40px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.slotRebate .symbolType .symbol-list .symbol li input {
  width: 100%;
  border: none;
  background: transparent;
  resize: none;
  outline: none;
  text-align: center;
}
.slotRebate .symbolType .symbol-list .symbol li input::placeholder,
.slotRebate .symbolType .symbol-list .symbol li input::-webkit-input-placeholder {
  color: #999;
  font-size: 14px;
  text-align: center;
  background: transparent;
  outline: none;
  resize: none;
}
.slotRebate .symbolType .symbol-list .symbol li input:-webkit-autofill,
.slotRebate .symbolType .symbol-list .symbol li input:-webkit-autofill:hover,
.slotRebate .symbolType .symbol-list .symbol li input:-webkit-autofill:focus {
  -webkit-text-fill-color: #333 !important;
  -webkit-box-shadow: inset 0 0 0 1000px #fff !important;
  box-shadow: inset 0 0 0 1000px #fff !important;
  outline: none;
  resize: none;
  text-align: center;
}
.slotFixedBtn {
  overflow: hidden;
  display: flex;
  justify-content: center;
}
</style>
